import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CircleStateFalseActiveOffIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CircleStateFalseActiveOffIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <circle cx="12" cy="12" r="10" fill="#F7F7F7" />
      <path
        d="M12.0005 22C6.48633 22 2 17.5137 2 12C2 6.48633 6.48584 2 12 2C17.5142 2 22 6.48633 22 12C22 17.5137 17.5142 22 12.0005 22ZM12.0005 3C7.03759 3 3 7.03711 3 12C3 16.9629 7.0376 21 12 21C16.9624 21 21 16.9629 21 12C21 7.03711 16.9629 3 12.0005 3Z"
        fill="#E3E4E8"
      />
    </svg>
  );
};

export default CircleStateFalseActiveOffIcon;
